import {
  PostReportYamadumiSupplierReqParams,
  PostReportYamadumiSupplierRes
} from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

export class PostReportYamadumiSupplierGateway {
  /** 業者山積表出力 */
  static postReportSupplier = async (
    params: PostReportYamadumiSupplierReqParams
  ) => {
    return await yamadumiApi.post<PostReportYamadumiSupplierRes>(
      '/api/report/yamadumi-supplier',
      { ...params }
    )
  }
}
